import { Center, Spinner, Text } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router-dom";
import { useGetNeedQuery } from "../../autogen/bff-api";
import { isFetchBaseQueryError } from "../../common/errors/isFetchBaseQueryError";
import { useApiError } from "../../common/errors/useApiError";
import { urls } from "../../urls";
import { NeedEditorRoot } from "./NeedEditorRoot";

export const EditNeed = () => {
  const { t } = useTranslation();
  const { needId } = useParams<{ needId: string }>();
  const { data, isLoading, isError, error, refetch } = useGetNeedQuery(needId ? { needId } : skipToken);
  const displayer = useApiError();

  if (!needId) return null;
  if (isLoading) {
    return (
      <Center py="20">
        <Spinner color="smPrimary" />
      </Center>
    );
  }
  if (isError || !data) {
    if (isFetchBaseQueryError(error) && error.status === 403) return displayer.showNoAccess();
    return (
      <Center py="20">
        <Text color="smMuted">{t("Could not load the need.")}</Text>
      </Center>
    );
  }
  if (!data.canEdit) {
    return <Navigate to={urls.app.needs.view.go(needId)} replace />;
  }

  return <NeedEditorRoot needId={needId} need={data} refetch={refetch} />;
};
